module.exports = __webpack_public_path__ + "static/media/loading_money.cae95ae6.gif";